export const AIChatCitationFragment = gql`
  fragment AIChatCitationFragment on AIChatCitation {
    id
    aiTrainingMaterial {
      ...AITrainingMaterialFragment
    }
    codeBookItem {
      formattedName
      codeBook {
        name
      }
    }
    scrapedFile {
      sourceUrl
      scrapedAt
    }
    violationCode {
      id
      corpus
      sectionName
      title
      display
    }
  }
`

export const AIChatResponseEventFragment = gql`
  fragment AIChatResponseEventFragment on AIChatResponseEvent {
    __typename
    ... on AIChatTextDelta {
      text
      done
    }
    ... on AIChatTextUpdate {
      fullText
      isGeneratingOtherProperties
      done
    }
  }
`

// This is the base fragment on the AIChat model to be used for all AI chat experiences (Community Assistant, AI Config Assistant, etc.)
export const AIChatBaseFragment = gql`
  fragment AIChatBaseFragment on AIChat {
    id
    questionCreatedAt
    question
    response
    user {
      ...UserDataFragment
    }
    userGaveThumbsUp
    userGaveThumbsDown
  }
`

export const AIAssistantChatAssociatedAIChatbotFAQFragment = gql`
  fragment AIAssistantChatAssociatedAIChatbotFAQFragment on AIChatbotFAQ {
    id
    question
    answer
    type
  }
`

export const AIAssistantChatFragment = gql`
  fragment AIAssistantChatFragment on AIChat {
    ...AIChatBaseFragment
    aiChatbotFAQ {
      ...AIAssistantChatAssociatedAIChatbotFAQFragment
    }
    citations {
      ...AIChatCitationFragment
    }
    currentUserIntent
    didSystemRespondWithSubstantiveAnswer
    responseCreatedAt
    session {
      id
      source
      sourceUrl
    }
  }
`
